import BaseTransform from "@/transforms/modules/base-transform";

export default {
    transform(item) {
        return {
            id: BaseTransform.transformNumeric(item, 'id'),
            customer_id: BaseTransform.transformNumeric(item, 'customer_id'),
            site_user_id: BaseTransform.transformString(item, 'site_user_id'),
            campaign_id: BaseTransform.transformNumeric(item, 'campaign_id'),
            point: BaseTransform.transformNumeric(item, 'point'),
            token: BaseTransform.transformString(item, 'token'),
            return_url: BaseTransform.transformString(item, 'return_url'),
            lang: BaseTransform.transformString(item, 'lang'),
            created: BaseTransform.transformDateFromTimestamp(item, 'created'),
            loyal_campaign: item && item.loyal_campaign && Object.keys(item.loyal_campaign).length > 0 ? this.transformLoyalCampaign(item.loyal_campaign) : {}
        };
    },

    transformLoyalCampaign(campaign){
        return {
            id: BaseTransform.transformNumeric(campaign, 'id'),
            giftset_id: BaseTransform.transformNumeric(campaign, 'giftset_id'),
            title: BaseTransform.transformString(campaign, 'title'),
            point_name: BaseTransform.transformString(campaign, 'point_name'),
            point_display: BaseTransform.transformNumeric(campaign, 'point_display'),
            point_url: BaseTransform.transformString(campaign, 'point_url'),
            exchange_rate: BaseTransform.transformNumeric(campaign, 'exchange_rate'),
            need_otp: BaseTransform.transformNumeric(campaign, 'need_otp'),
            show_logo: BaseTransform.transformNumeric(campaign, 'show_logo'),
            show_banner: BaseTransform.transformNumeric(campaign, 'show_banner'),
            show_filter: BaseTransform.transformNumeric(campaign, 'show_filter'),
            allow_sgff: BaseTransform.transformNumeric(campaign, 'allow_sgff'),
            rate_type: BaseTransform.transformNumeric(campaign, 'rate_type'),
            status: BaseTransform.transformNumeric(campaign, 'status'),
            has_api_expired: BaseTransform.transformNumeric(campaign, 'has_api_expired'),
            app_id: BaseTransform.transformNumeric(campaign, 'app_id'),
        }
    }
}
